import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Header from "../components/landing/Header";
import Hero from "../components/landing/Hero";
import Seo from "../components/Seo";
import HowItWorks from "../components/landing/HowItWorks";
import Features from "../components/landing/Features";
import WhyChoose from "../components/landing/WhyChoose";
import ReferentPitch from "../components/landing/ReferentPitch";
import Pricing from "../components/landing/Pricing";
import Footer from "../components/landing/Footer";

function FinalCTA() {
  const navigate = useNavigate();
  return (
    <section className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-5 lg:px-8">
        <div className="relative rounded-[10px] bg-brand-graphite overflow-hidden px-8 py-16 lg:p-20 text-center">
          <div className="relative">
            <h2 className="font-display text-4xl lg:text-5xl font-semibold text-white max-w-2xl mx-auto leading-tight">
              Passez moins de temps sur votre gestion locative.
            </h2>
            <p className="mt-5 text-lg text-white/70 max-w-xl mx-auto">
              Créez votre compte gratuit en quelques minutes. Sans engagement.
            </p>
            <button
              onClick={() => navigate("/connexion")}
              className="group mt-8 inline-flex items-center gap-2 px-8 py-4 rounded-full bg-brand-lime hover:bg-brand-limeDark text-brand-greenDeep font-semibold text-lg transition-all shadow-lg"
              data-testid="final-cta"
            >
              Créer mon compte gratuit
              <ArrowUpRight className="w-5 h-5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default function LandingPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="bg-white">
      <Seo
        title="Logiciel de gestion locative avec IA | 360immoinvest"
        description="Quittances de loyer, suivi des paiements, révision IRL, régularisation des charges et aide à la déclaration des revenus fonciers. Gratuit pour 1 bien."
        path="/"
      />
      <Header />
      <Hero />
      <HowItWorks />
      <Features />
      <WhyChoose />
      <ReferentPitch />
      <Pricing />
      <FinalCTA />
      <Footer />
    </div>
  );
}
